// extracted by mini-css-extract-plugin
export default {"icon":"r5Y1VFEpgMdsqZ6auTyn"};